import { useMedia } from "react-use"

import { Sex } from "utils/interfaces"

export const MARITAL_STATUS_MARRIED = "married"
export const MARITAL_STATUS_SINGLE = "single"

export function genderedMaritalStatus(
    status: typeof MARITAL_STATUS_MARRIED | typeof MARITAL_STATUS_SINGLE,
    sex: Sex | undefined
) {
    if (status === MARITAL_STATUS_MARRIED) {
        if (sex === Sex.Female) return "Замужем"
        if (sex === Sex.Male) return "Женат"
        return "Замужем/Женат"
    }
    if (status === MARITAL_STATUS_SINGLE) {
        if (sex === Sex.Female) return "Не замужем"
        if (sex === Sex.Male) return "Не женат"
        return "Не замужем/Не женат"
    }
    return ""
}

export function useIsTablet() {
    return useMedia("(min-width: 992px)")
}
